import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./lib/AuthContext";
import AnalyticsTracker from "./lib/AnalyticsTracker";
import LandingPage from "./pages/LandingPage";
import RetrouperInformation from "./pages/RetrouperInformation";
import RetrouperDocument from "./pages/RetrouperDocument";
import PerteInformation from "./pages/PerteInformation";
import CentraliserInformation from "./pages/CentraliserInformation";
import ProductiviteEquipe from "./pages/ProductiviteEquipe";
import CloneCollaborateur from "./pages/CloneCollaborateur";
import MemoireEntreprise from "./pages/MemoireEntreprise";
import EntrepriseInterrogeable from "./pages/EntrepriseInterrogeable";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminBlog from "./pages/admin/AdminBlog";
import BlogIndex from "./pages/BlogIndex";
import DynamicBlogArticle from "./pages/DynamicBlogArticle";
import TeamPage from "./pages/TeamPage";
import ContactPage from "./pages/ContactPage";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <div className="App">
            <AnalyticsTracker />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/retrouver-information-entreprise" element={<RetrouperInformation />} />
              <Route path="/retrouver-information-document-entreprise" element={<RetrouperDocument />} />
              <Route path="/perte-information-entreprise" element={<PerteInformation />} />
              <Route path="/centraliser-information-entreprise" element={<CentraliserInformation />} />
              <Route path="/productivite-equipe-outil" element={<ProductiviteEquipe />} />
              <Route path="/clone-collaborateur-entreprise" element={<CloneCollaborateur />} />
              <Route path="/memoire-entreprise-futur-travail" element={<MemoireEntreprise />} />
              <Route path="/entreprise-interrogeable" element={<EntrepriseInterrogeable />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<DynamicBlogArticle />} />
              <Route path="/equipe" element={<TeamPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="leads" element={<AdminLeads />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="blog" element={<AdminBlog />} />
              </Route>
            </Routes>
            <Toaster position="top-right" />
          </div>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
